import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Label,
  InputGroupAddon,
  Button,
  Table
} from "reactstrap";
import qs from "query-string";
import Switch from "react-toggle-switch";
import parseDate from "../../helpers/parseDate";
import alphabetizeBy from "../../helpers/alphabetizeBy";
import LoaderSpinner from "../Widgets/LoaderSpinner";
import ConfirmDelete from "../Components/ConfirmDelete";
import authProtection from "../../HOCs/authProtection";
import withAlertTimeout from "../../HOCs/withAlertTimeout";
import Alert from "../Widgets/Alert";
import BusinessAdminsModal from "../Components/BusinessAdminsModal";
import { CLOUDINARY_THUMB } from "../../helpers/cloudinaryConstants";
import EnterNetlifyID from "../Components/EnterNetlifyID";
import DeleteNetlifyID from "../Components/DeleteNetlifyID";
import BuildNetlify from "../Components/BuildNetlify"
class SearchBusinesses extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      nameQuery: "",
      cityQuery: "",
      isSubmitting: false,
      searchResults: [],
      noResults: false,
      showConfirmationModal: false,
      showNetlifyIDModal: false,
      showNetlifyDeleteModal: false,
      showNetlifyBuildModal: false,
      selectedBusiness: null,
      isDeleting: false,
      isLinking: false,
      isBuilding: false,
      showModal: false,
      netlifyID: "",
      successMessage: ""
    };

    this.onQueryInput = this.onQueryInput.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
    this.onNetlifyLinkClick = this.onNetlifyLinkClick.bind(this)
    this.onNetlifyRemoveLinkClick = this.onNetlifyRemoveLinkClick.bind(this)
    this.onNetlifyBuildLinkClick = this.onNetlifyBuildLinkClick.bind(this)
    this.goToBusinessPage = this.goToBusinessPage.bind(this);
    this.onPoweredToggle = this.onPoweredToggle.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.deleteBusiness = this.deleteBusiness.bind(this);
    this.updateNetlifyID = this.updateNetlifyID.bind(this);
    this.getNetlifyID = this.getNetlifyID.bind(this)
    this.onLinkNetlify = this.onLinkNetlify.bind(this);
    this.onBuildNetlify = this.onBuildNetlify.bind(this)
    this.showModal = this.showModal.bind(this);
    this.isSuperAdmin = false;
  }

  componentDidMount() {
    document.querySelector("#business-name-input").focus();

    const user = JSON.parse(sessionStorage.getItem("user"));
    if (
      user.privyData.group.goNation.some(item => item.name === "SuperAdmin")
    ) {
      this.isSuperAdmin = true;
    }
  }

  closeModal() {
    this.setState({ showConfirmationModal: false, showNetlifyIDModal: false, showNetlifyDeleteModal: false, showNetlifyBuildModal: false, selectedBusiness: null });
  }

  onQueryInput(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onKeyPress(e) {
    if (e.charCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      this.onSubmitClick();
    }
  }

  onDeleteClick(businessId) {
    return e => {
      e.stopPropagation();
      this.setState({
        showConfirmationModal: true,
        selectedBusiness: businessId
      });
    };
  }

  

  onNetlifyLinkClick(businessId) {
    return e => {
      e.stopPropagation();
      this.setState({
        showNetlifyIDModal: true,
        selectedBusiness: businessId
      }, () => {this.getNetlifyID()});
      
    };
  }

  onNetlifyRemoveLinkClick(businessId) {
    return e => {
      e.stopPropagation();
      this.setState({
        showNetlifyDeleteModal: true,
        selectedBusiness: businessId,
        netlifyID: ''
      });
    };
  }

  onNetlifyBuildLinkClick(businessId) {
    return e => {
      e.stopPropagation();
      this.setState({
        showNetlifyBuildModal: true,
        selectedBusiness: businessId,
      }, () => this.getNetlifyID());
    };
  }

  onSubmitClick() {
    const token = sessionStorage.getItem("token");

    this.setState({ isSubmitting: true, noResults: false });

    const headers = { headers: { Authorization: `Bearer ${token}` } };

    let url = "/api/proxy/v2/businesses";

    const query = {};

    if (this.state.nameQuery) {
      query.name = this.state.nameQuery;
    }

    if (this.state.cityQuery) {
      query.geofence = this.state.cityQuery;
    }

    axios
      .get(`/api/proxy/v2/businesses?${qs.stringify(query)}`, headers)
      .then(({ data }) => {
        this.setState({
          isSubmitting: false,
          searchResults: alphabetizeBy("name", data.items),
          noResults: !data.items.length
          
        });
      })
      .catch(err => {
        this.setState({ isSubmitting: false, searchResults: [] });
        console.log(err);
      });
  }

  onPoweredToggle(e, business) {
    e.stopPropagation();
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    axios
      .patch(
        `/api/proxy/v2/businesses/${business.id}/settings`,
        { powered: !business.publishableData.powered },
        { headers }
      )
      .then(({ data }) => {
        const businessIdx = this.state.searchResults.findIndex(
          biz => biz.id === business.id
        );
        const searchResults = [...this.state.searchResults];
        searchResults[businessIdx].publishableData.powered = data.powered;
        this.setState({ searchResults });
      })
      .catch(err => {
        console.log(err);
      });
  }

  goToBusinessPage(business) {
    return () => {
      const win = window.open(
        `${APP_BASE_URL}/place/${business.slug}`,
        "_blank"
      );
      win.focus();
    };
  }

  showModal(business) {
    return e => {
      e.stopPropagation();
      this.setState({ showModal: true, selectedBusiness: business });
    };
  }

  deleteBusiness() {
    if (this.isSuperAdmin) {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const payload = {
        gnObjectType: "business",
        gnObjectId: this.state.selectedBusiness
      };

      this.setState({ isDeleting: true });

      axios({
        url: "/api/proxy/v2/flags/objects",
        method: "delete",
        data: payload,
        headers
      })
        .then(({ data }) => {
          this.setState({ isDeleting: false, successMessage: "Successfully Deleted." });
          window.scrollTo(0, 0);
          this.props.showSuccess();
          this.onSubmitClick();
          this.closeModal();
        })
        .catch(err => {
          this.setState({ isDeleting: false });
          this.props.showFailure();
          console.log(err);
        });
    }
  }

  updateNetlifyID(id) {
    this.setState({netlifyID: id})
  };

  getNetlifyID() {
    const token = sessionStorage.getItem("token");
    const headers = { headers: { Authorization: `Bearer ${token}` } };
    axios
    .get(`/api/proxy/v2/businesses/${this.state.selectedBusiness}/settings`, headers)
    .then(({ data }) => {
      if(data.netlifyId)
      {
        this.setState({
          netlifyID: data.netlifyId
        },() => {this.forceUpdate()});
      }
      else{
        this.setState({
          netlifyID: ''
        },() => {this.forceUpdate()});
      }
    })
    .catch(err => {
      console.log(err);
    });
  }

  onLinkNetlify() {
    
    this.setState({isLinking: true})
    const token = sessionStorage.getItem('token')
    const headers = { Authorization: `Bearer ${token}` }

    const netlifyId = this.state.netlifyID
    if(netlifyId) this.setState({successMessage: "Successfully Linked."})
    else this.setState({successMessage: "Successfully Deleted."})
    axios
      .patch(
        `api/proxy/v2/businesses/${this.state.selectedBusiness}/settings`,
        {
          netlifyId: netlifyId,
        },
        { headers }
      )
      .then(response => {
        this.setState({ isLinking: false, netlifyID: "" });
        window.scrollTo(0, 0);
        this.props.showSuccess();
        this.onSubmitClick();
        this.closeModal();
      })
      .catch(err => {
        this.setState({ isLinking: false });
        this.props.showFailure();
        console.log(err);
      })
  }
  
  onBuildNetlify() {
    this.setState({isBuilding: true, successMessage: "Building Site..."})
    const netlifyId = this.state.netlifyID
    axios
    .post(
      `https://api.netlify.com/build_hooks/${netlifyId}`
    )
    .then(response => {
      this.setState({ isBuilding: false});
      window.scrollTo(0, 0);
      this.props.showSuccess();
      this.closeModal();
    })
    .catch(err => {
      this.setState({ isBuilding: false });
      this.props.showFailure();
      console.log(err);
    })
  }

  renderResults() {
    return this.state.searchResults.map(business => (
      <tr
        onClick={
          this.props.onSelect
            ? this.props.onSelect(business)
            : this.goToBusinessPage(business)
        }
        key={business.id}
        className="user-table__item"
      >
        <td className="text-center">
          <div className="avatar">
            <img
              src={`${CLOUDINARY_THUMB}/${business.avatar.image.cloudinaryId}`}
              className="img-avatar"
              alt={business.name}
            />
          </div>
        </td>
        <td>
          <div>{business.name}</div>
          <div className="small text-muted">
            Created On: {parseDate(business.createdAt)}
          </div>
        </td>
        <td className="text-center">
          {business.id}
          <div onClick={this.showModal(business)} style={{ color: "#20bed6" }}>
            View Admins
          </div>
        </td>
        <td className="text-center">{business.slug}</td>

        <td className="text-center">
          {business.location.geofence.displayName}
        </td>
        <td className="text-center">
        {!business.hasNetlifyId || !business.privyData.netlifyId ? (
          <i
            className="fa fa-link"
            style={{ fontSize: 20, marginRight: 5, color: "#20BED6" }}
            onClick={this.onNetlifyLinkClick(business.id)}
          />
         ) : (<div><i
          className="fa fa-edit"
          style={{ fontSize: 16, marginRight: 8, color: "#D1A52F" }}
          onClick={this.onNetlifyLinkClick(business.id)}
        />
        <i
          className="fa fa-trash"
          style={{ fontSize: 16, marginRight: 8, color: "#F2014B" }}
          onClick={this.onNetlifyRemoveLinkClick(business.id)}
        />
        <i
          className="fa fa-wrench"
          style={{ fontSize: 16, marginRight: 2, color: "#26BA5F" }}
          onClick={this.onNetlifyBuildLinkClick(business.id)}
        /></div>)
        }
        </td>
        {this.isSuperAdmin && (
          <td className="text-center">
            <Button
              disabled={!this.isSuperAdmin}
              onClick={this.onDeleteClick(business.id)}
              color="danger"
            >
              Delete
            </Button>
          </td>
        )}
        {business.publishableData && (
          <td className="text-center">
            <Switch
              onClick={e => this.onPoweredToggle(e, business)}
              on={business.publishableData.powered}
              enabled={this.isSuperAdmin}
            />
            <br />
            {business.publishableData.powered && business.privyData.poweringId}
          </td>
        )}
      </tr>
    ));
  }

  render() {
    return [
      <ConfirmDelete
        key="modal"
        prompt="Are you sure you want to permanently delete this business?"
        open={this.state.showConfirmationModal}
        onClose={this.closeModal}
        onConfirm={this.deleteBusiness}
        buttonsDisabled={this.state.isDeleting}
      />,
      <EnterNetlifyID
        key="netlifyModal"
        open={this.state.showNetlifyIDModal}
        onClose={this.closeModal}
        onChange={this.updateNetlifyID}
        onLinkNetlify={this.onLinkNetlify}
        buttonsDisabled={this.state.isLinking}
        inputValue={this.state.netlifyID}
      />,
      <DeleteNetlifyID
        key="deleteNetlifyModal"
        open={this.state.showNetlifyDeleteModal}
        onClose={this.closeModal}
        onLinkNetlify={this.onLinkNetlify}
        buttonsDisabled={this.state.isLinking}
      />,
      <BuildNetlify
        key="buildNetlifyModal"
        open={this.state.showNetlifyBuildModal}
        onClose={this.closeModal}
        onBuildNetlify={this.onBuildNetlify}
        buttonsDisabled={this.state.isBuilding}
      />,
      <BusinessAdminsModal
        key="adminsmodal"
        isOpen={
          this.state.selectedBusiness !== null &&
          !this.state.showConfirmationModal &&
          !this.state.showNetlifyIDModal &&
          !this.state.showNetlifyDeleteModal &&
          !this.state.showNetlifyBuildModal
        }
        business={this.state.selectedBusiness}
        close={this.closeModal}
      />,
      <div key="searchbusiness" className="animated fadeIn">
        {<Alert active={this.props.success} message={this.state.successMessage} />}
        {
          <Alert
            type="danger"
            active={this.props.failure}
            message="Something went wrong, please try again"
          />
        }
        <Row>
          <Col xs="12">
            <Card>
              <CardHeader>Search for a Business by Name</CardHeader>
              <CardBody>
                <FormGroup>
                  <Label htmlFor="business name">Business Name</Label>
                  <Input
                    type="search"
                    name="nameQuery"
                    id="business-name-input"
                    placeholder="e.g. Mighty's Restaurant"
                    value={this.state.nameQuery}
                    onKeyPress={this.onKeyPress}
                    onChange={this.onQueryInput}
                  />
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="business name">City Name</Label>
                  <Input
                    type="search"
                    name="cityQuery"
                    placeholder="e.g. Milford, CT"
                    value={this.state.cityQuery}
                    onKeyPress={this.onKeyPress}
                    onChange={this.onQueryInput}
                  />
                </FormGroup>
                <div className="form-actions">
                  <Button
                    onClick={this.onSubmitClick}
                    type="submit"
                    color="primary"
                    disabled={this.state.isSubmitting}
                  >
                    Search
                  </Button>
                </div>
              </CardBody>
            </Card>
            {this.state.isSubmitting && <LoaderSpinner />}
            {this.state.noResults && (
              <h4 style={{ textAlign: "center" }}>No Businesses Found</h4>
            )}
            {this.state.searchResults.length ? (
              <Table
                hover
                responsive
                className="table-outline mb-0 d-none d-sm-table user-table"
              >
                <thead className="thead-light">
                  <tr>
                    <th className="text-center">
                      <i className="icon-people" />
                    </th>
                    <th>Name</th>
                    <th className="text-center">ID</th>
                    <th className="text-center">Slug</th>
                    <th className="text-center">Geofence</th>
                    <th className="text-center">Build Hook (NetlifyID)</th>
                    {this.isSuperAdmin && (
                      <th className="text-center">Delete</th>
                    )}
                    <th className="text-center">Powered</th>
                  </tr>
                  {this.renderResults()}
                </thead>
                <tbody />
              </Table>
            ) : null}
          </Col>
        </Row>
      </div>
    ];
  }
}

export default authProtection(withAlertTimeout(SearchBusinesses));



// WEBPACK FOOTER //
// ./src/views/Pages/SearchBusinesses.js